import posthog from "posthog-js"

let _initialized = false

function isLocalhost() {
  if (typeof window === "undefined") return false
  const { hostname } = window.location
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "::1" ||
    hostname.endsWith(".local")
  )
}

export function init() {
  if (_initialized) return
  if (typeof window === "undefined") return
  if (isLocalhost()) return
  if (!process.env.GATSBY_POSTHOG_API_KEY) return
  posthog.init(process.env.GATSBY_POSTHOG_API_KEY, {
    api_host: process.env.GATSBY_POSTHOG_HOST,
    autocapture: false,
    capture_pageview: false,
  })
  _initialized = true
}

export function capturePageview(path) {
  if (typeof window === "undefined") return
  if (isLocalhost()) return
  init()
  posthog.capture("$pageview", path ? { $current_url: path } : {})
}

export function capture(event, properties) {
  if (typeof window === "undefined") return
  if (isLocalhost()) return
  init()
  posthog.capture(event, properties || {})
}
